export default __webpack_public_path__ + "static/media/ticket_success.cc0aa275.svg";